<h3>DIVULGAZIONE</h3>
<p>Le attività della De Cifris comprendono, fra le molte cose,
	la gestione di riviste scientifiche e divulgative, l'organizzazione
	di seminari, gare, sfide ed eventi pubblici qualificanti.
	Tra le nostre attività elenchiamo: </p>
<ul>
	<li>
		<b>I video di De Cifris Historiae </b>
		<p>Di seguito il link ai video del nostro ciclo di seminari De Cifris Historiae.</p>
		<ul>
			<li>
				<a href="https://www.youtube.com/watch?v=v3jGrVNa4H8" target="_blank">La Crittografia nella Roma
					Antica</a>
			</li>
		</ul>
	</li>
	<br>
	<li>
		<b>Articoli divulgativi</b>
		<p>Le attività della De Cifris comprendono la condivisione libera di piccoli
			documenti divulgativi realizzati dai membri della nostra iniziativa.
			Di seguito una breve collezione di tali articoli, soprattutto da un
			lato storico. </p>
		<p>Per contribuire, scrivi a <a href="mailto:seminari@decifris.it">
				seminari&#64;decifris.it</a></p>
		<p>Qui di seguito un elenco degli articoli caricati: </p>
		<ul>
			<li> <a href="../../../assets/attivita/divulgazione/Gnosis-CrittografiaIntroduzione.pdf" target="_blank">
					<b>La sicurezza nell'Impero delle Comunicazioni</b></a>:<br>
				Brevissima introduzione alla Crittografia.
				<p></p>
			</li>
			<li> <a href="../../../assets/attivita/divulgazione/Gnosis-CrittografiaAntica.pdf" target="_blank"><b>La
						Crittografia. Dalle oscure origini al Rinascimento italiano</b></a>:<br>
				Breve excursus storico che contiene anche una discussione dei principi base dell'arte crittografica.
				<p></p>
			</li>
			<li> <a href="../../../assets/attivita/divulgazione/Gnosis-CrittografiaPrebellica.pdf" target="_blank">
					<b>La Crittografia. Da raffinata arte rinascimentale a moderna scienza</b></a>:<br>
				Questa digressione storica si concentra sul progresso della crittografia nel periodo post Rinascimentale
				fino ad arrivare alle Guerre Mondiali. In questa fase, la crittografia ha registrato un passaggio da
				ricercata arte - utile a diplomazie ed eserciti - a disciplina scientifica - utile a tutta la società e
				alla
				vita quotidiana.
				<p></p>
			</li>
			<li> <a href="../../../assets/attivita/divulgazione/Gnosis-CrittografiaPubblica.pdf" target="_blank"><b> I
						pratici effetti dell'astrazione matematica nella Crittografia</b></a>:<br>
				Breve excursus sulla nascita della Crittografia a chiave pubblica con considerazioni di carattere
				scientifico.
				L'ubiquità del sistema di telecomunicazioni ha permesso la dislocazione di un gran numero di operazioni
				presso l'utente, quali servizi bancari e postali, vendite e transazioni commerciali, ponendo problemi di
				sicurezza sconosciuti in passato. La tecnologia crittografica è maturata per assicurare funzionalità e
				sicurezza agli strumenti indispensabili di questo assetto globale.
				<p></p>
			</li>
			<li> <a href="../../../assets/attivita/divulgazione/Gnosis-CrittografiaFutura.pdf" target="_blank"> <b> ll
						Futuro della Crittografia teorica e pragmatica e il Post-Quantum</b></a>:<br>
				In questo articolo si trattano i futuri sviluppi teorici e pratici della Crittografia, in conseguenza
				dell'incremento delle tecnologie
				microelettroniche volte alla realizzazione di microprocessori sempre più veloci e del recente
				potenziamento degli elaboratori basati sulla meccanica
				quantistica.
				<p></p>
			</li>
			<li> <a href="../../../assets/attivita/divulgazione/Gnosis-CrittografiaEnigmaI.pdf" target="_blank"> <b>Il
						caso Enigma. La storia 1</b></a>:<br>
				Prima parte di un articolo che tratta brevemente la storia di Enigma, la macchina cifrante impiegata
				dalla Germania durante la Seconda
				Guerra Mondiale. Gli autori raccontano gli eventi salienti e pongono in risalto i ruoli dei personaggi
				principali, in forma appassionante e fedele alla realtà dei fatti.
				<p></p>
			</li>
		</ul>
	</li>
</ul>
<hr>
<h4>INIZIATIVE PASSATE</h4>
<ul>
	<li>
		<b>Salotto online: Immuni...e Contenti?</b>
		<p> Questa sezione è stata ideata per poter permettere un confronto
			e una analisi di un tema caldo in questo particolare momento storico:
			il contact tracing. Con questi <a href="https://www.youtube.com/watch?v=qB04xaQs470&list=PLu4yxTVzRRMWb0tBZd
						906hrcQE-MZuNsm" target="_blank">video</a>, in cui gli esperti hanno presentao le loro
			idee/opinioni/ricerche, si voleva alimentare il dibattito anche sulla
			Applicazione <i>IMMUNI</i>.
		<p> Per contribuire al dibattito, si potevano inviare dei brevi video
			in cui venenivano riassunti gli studi/opinioni
			sul tema, con un link agli articoli, post sui social, etc. in cui erano
			stati presentati. I video sono stati poi selezionati e pubblicati sul
			<a href="https://www.youtube.com/channel/UCTgLUneI3agkv_FcW0RlI0A" target="_blank">nostro canale YouTube
			</a>.
		</p>
	</li>
	<li>
		<b>Cryptowars</b>
		<p>
			Nel corso degli anni passati abbiamo organizzato le <a routerLink="/cryptowars">cryptowars</a>, delle gare
			crittografiche
			che hanno lo scopo, fra i tanti, di diffondere e divulgare argomenti di carattere crittografico.
		</p>
	</li>
	<li>
		<b>100 Tesi</b>
		<p>
			Tra il 2008 e il 2017 abbiamo raccolto in un volume 100 tesi di Crittografia.
			Il <a href="http://www.aracneeditrice.it/aracneweb/index.php/pubblicazione.html?item=9788825527520"
				target="_blank">
				volume</a> contiene un breve riassunto in italiano delle tesi, dando enfasi chiaramente
			alla crittografia, ma lasciando anche spazio ad argomenti collegati, in particolare
			alla teoria dei codici.
		</p>
	</li>
</ul>